var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPatio = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(8 12)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#58595B",
  d: "M3.1.5v11.8M7.6.5v11.8M12 .5v11.8M16.4.5v11.8M20.9.5v11.8"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.1,
  cy: 6.1,
  r: 1,
  stroke: "#58595B"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7.6,
  cy: 6.1,
  r: 1,
  stroke: "#58595B"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 6.1,
  r: 1,
  stroke: "#58595B"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16.4,
  cy: 6.1,
  r: 1,
  stroke: "#58595B"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20.9,
  cy: 6.1,
  r: 1,
  stroke: "#58595B"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 2.9,
  r: 1,
  fill: "#58595B",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 9.7,
  r: 1,
  fill: "#58595B",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16.4,
  cy: 2.9,
  r: 1,
  fill: "#58595B",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16.4,
  cy: 9.7,
  r: 1,
  fill: "#58595B",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20.9,
  cy: 3,
  r: 1,
  fill: "#58595B",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20.9,
  cy: 9.8,
  r: 1,
  fill: "#58595B",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7.6,
  cy: 3,
  r: 1,
  fill: "#58595B",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7.6,
  cy: 9.8,
  r: 1,
  fill: "#58595B",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.1,
  cy: 3,
  r: 1,
  fill: "#58595B",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.1,
  cy: 9.8,
  r: 1,
  fill: "#58595B",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#58595B",
  d: "M23 13.4c0 1.2-1 2.2-2.2 2.2H3c-1.2 0-2.2-1-2.2-2.2v-1.1H23zM0 .5h24"
}))));
export default SvgPatio;